import { Component, Input } from '@angular/core';
import { BucketService, fileColorMap, FileNode } from 'src/app/services/bucket/bucket.service';

@Component({
  selector: 'app-file-card-documenti',
  standalone: false,

  templateUrl: './file-card-documenti.component.html',
  styleUrl: './file-card-documenti.component.scss',
})
export class FileCardDocumentiComponent {
  constructor(private readonly _bucketService: BucketService) {}

  protected _file: FileNode | undefined;

  @Input()
  set file(file: FileNode | undefined) {
    this._file = file;
  }

  get file(): FileNode | undefined {
    return this._file;
  }
  protected _isModulo: boolean = false;

  @Input()
  set isModulo(isModulo: boolean) {
    this._isModulo = isModulo;
  }

  get isModulo(): boolean {
    return this._isModulo;
  }

  fileColorMap = fileColorMap;

  public getLogoFile(file: FileNode): string {
    return this._bucketService.getLogoFile(file.extension);
  }
}
